import { render, staticRenderFns } from "./DaysVDistributionTable.vue?vue&type=template&id=449feb42&"
import script from "./DaysVDistributionTable.vue?vue&type=script&lang=js&"
export * from "./DaysVDistributionTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports